



































import { Component, Vue } from 'vue-property-decorator';
import { ApiClient, apiClient } from '@/api/ApiClient';
import moment from 'moment';
import OptionalValue from '@/components/OptionalValue.vue';
import camelcase from 'camelcase';
import { dateRangeTodayUntilEnd } from '@/utils/helper';

@Component({
  components: {
    OptionalValue,
  },
})
export default class extends Vue {

  public get moment() {
    return moment;
  }

  // table filter
  public range: Date[] = dateRangeTodayUntilEnd();
  public byId: number = null;
  public customerId: number = null;
  public orderByColumn: string = null;
  public orderByOrder: string = null;

  // table
  public isTableLoading = false;

  public pageSize = 100;
  public total = 0;
  public currentPage = 1;

  public data: any[] = [];
  public accounts: any[] = [];
  public customers: any[] = [];
  public applications: any[] = [];

  public mounted() {
    this.loadData();
  }

  // table events
  public async onPaginationChange() {
    await this.loadTransactions();
    this.$scrollTo("#data-table");
  }

  // sort
  public async tableSortChange({ column, prop, order }) {
    if (prop && order) {
      this.orderByColumn = camelcase(prop.replace('.', '_'));
      this.orderByOrder = order.startsWith("asc") ? "ASC" : 'DESC';
    } else {
      this.orderByOrder = this.orderByColumn = null;
    }
    return this.loadTransactions();
  }

  //
  private async loadData() {
    await Promise.all([
      this.loadTransactions(),
      this.loadAccounts(),
      this.loadCustomers(),
    ]);
  }

  private async loadAccounts() {
    const { data } = await apiClient.accounts({
      take: Number.MAX_SAFE_INTEGER,
    });
    this.accounts = data.data;
  }

  private async loadCustomers() {
    const { data } = await apiClient.customers({
      take: Number.MAX_SAFE_INTEGER,
    });
    this.customers = data.data;
  }

  private async loadTransactions() {
    this.isTableLoading = true;
    const range = this.range || [];

    const { data } = await apiClient.transactions({
      take: this.pageSize,
      page: this.currentPage,

      orderByColumn: this.orderByColumn,
      orderByOrder: this.orderByOrder,

      customerId: this.customerId || undefined,
      byId: this.byId || undefined,
      from: range[0],
      to: range[1],
    });

    this.total = data.count;
    this.data = data.data;
    this.isTableLoading = false;
  }

  private async onRefund(row) {
    try {
      await this.$confirm(
        `Are you sure to refund transaction ${
          row.id
        }?`,
        this.$t('notify["Warning"]').toString(),
        {
          confirmButtonText: this.$t('global["OK"]').toString(),
          cancelButtonText: this.$t('global["Cancel"]').toString(),
          type: "warning"
        }
      );
    } catch (e) {
      console.log(e);
      return;
    }
  }

}
